import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../helper/Api";
import Toastify from "../helper/Toastify";

const initialState = {
  isLoading: false,
  isRefresh: false,
  catSubCategoriesData: {},
  ratingData: {},
  courseLevelData: {},
  filterValues: {
    search: "",
    sortBy: "All",
    subCategoryIds: "",
    ratings: "",
    courseLevels: "",
    minPrice: 1,
    maxPrice: 1000000,
    priceOption: "all",
    durationOptions: "",
    page: 1,
  },
  paymentData: {},
  durationData: {},
  allCourseData: {},
  courseDetailsData: {},
  reviewData: {},
  urlData: {},
  quizData: {},
  progressDetailsData: {},
  liveSessionData: {},
  submittedQuizScoreData: {},
  activeAssignmentData: {},
  getCommentData: {},
  submittedAssignmentData: {},
  certificateData: {},
  errorMsg: "",
  isError: false,
};

export const getCatSubCategories = createAsyncThunk(
  "getCatSubCategories",
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const { data, status } = await api.getCatSubCategories(body);
      dispatch(setLoading(true));

      if (status === 200) {
        dispatch(setLoading(false));
        dispatch(setCatSubCategories(data.data));
      }
      return data.data;
    } catch (err) {
      dispatch(setLoading(false));
      Toastify.error(err.response.data.message);
      return rejectWithValue(
        err.response.data.message ||
        "'Something went wrong. Please try again later.'"
      );
    }
  }
);
export const getRating = createAsyncThunk(
  "getRating",
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const { data, status } = await api.getRating(body);
      dispatch(setLoading(true));

      if (status === 200) {
        dispatch(setLoading(false));
        dispatch(setRating(data.data));
      }
      return data.data;
    } catch (err) {
      dispatch(setLoading(false));
      Toastify.error(err.response.data.message);
      return rejectWithValue(
        err.response.data.message ||
        "'Something went wrong. Please try again later.'"
      );
    }
  }
);
export const getCourseLevel = createAsyncThunk(
  "getCourseLevel",
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const { data, status } = await api.getCourseLevel(body);
      dispatch(setLoading(true));

      if (status === 200) {
        dispatch(setLoading(false));
        dispatch(setCourseLevel(data.data));
      }
      return data.data;
    } catch (err) {
      dispatch(setLoading(false));
      Toastify.error(err.response.data.message);
      return rejectWithValue(
        err.response.data.message ||
        "'Something went wrong. Please try again later.'"
      );
    }
  }
);
export const getPayment = createAsyncThunk(
  "getPayment",
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const { data, status } = await api.getPayment(body);
      dispatch(setLoading(true));

      if (status === 200) {
        dispatch(setLoading(false));
        dispatch(setPayment(data.data));
      }
      return data.data;
    } catch (err) {
      dispatch(setLoading(false));
      Toastify.error(err.response.data.message);
      return rejectWithValue(
        err.response.data.message ||
        "'Something went wrong. Please try again later.'"
      );
    }
  }
);
export const getDuration = createAsyncThunk(
  "getDuration",
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const { data, status } = await api.getDuration(body);
      dispatch(setLoading(true));

      if (status === 200) {
        dispatch(setLoading(false));
        dispatch(setDuration(data.data));
      }
      return data.data;
    } catch (err) {
      dispatch(setLoading(false));
      Toastify.error(err.response.data.message);
      return rejectWithValue(
        err.response.data.message ||
        "'Something went wrong. Please try again later.'"
      );
    }
  }
);
export const getAllCourses = createAsyncThunk(
  "getAllCourses",
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const queryParams = new URLSearchParams(body).toString();
      const { data, status } = await api.getAllCourses(queryParams);
      console.log("data================", data);

      if (status === 200) {
        //get categories data
        dispatch(setCourses(data.data));
      }
      return data.data;
    } catch (err) {
      return rejectWithValue(
        err.response.data.message ||
        "'Something went wrong. Please try again later.'"
      );
    }
  }
);
export const getCourseDetails = createAsyncThunk(
  "getCourseDetails",
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const { data, status } = await api.getCourseDetails(body);
      if (status === 200) {
        //get categories data
        dispatch(setCourseDetails(data.data));
      }
      return data.data;
    } catch (err) {
      return rejectWithValue(
        err.response.data.message ||
        "'Something went wrong. Please try again later.'"
      );
    }
  }
);

export const getCourseDetailsByCategory = createAsyncThunk(
  "getCourseDetailsByCategory",
  async (body, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setCourseDetails({}))
      const { data, status } = await api.getCourseDetailsByCategory(body);
      if (status === 200) {
        //get categories data
        dispatch(setCourseDetails(data.data));
      }

      return data.data;
    } catch (err) {
      return rejectWithValue(
        err.response.data.message ||
        "'Something went wrong. Please try again later.'"
      );
    }
  }
);
export const getReviews = createAsyncThunk(
  "getReviews",
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const { data, status } = await api.getReviews(body);
      if (status === 200) {
        //get categories data
        dispatch(setReviews(data.data));
      }
      return data.data;
    } catch (err) {
      return rejectWithValue(
        err.response.data.message ||
        "'Something went wrong. Please try again later.'"
      );
    }
  }
);
export const getUrl = createAsyncThunk(
  "getUrl",
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const { data, status } = await api.getUrl(body);
      if (status === 200) {
        //get categories data
        dispatch(setURL(data.data));
      }
      return data.data;
    } catch (err) {
      return rejectWithValue(
        err.response.data.message ||
        "'Something went wrong. Please try again later.'"
      );
    }
  }
);
export const getQuiz = createAsyncThunk(
  "getQuiz",
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const { data, status } = await api.getQuiz(body);
      if (status === 200) {
        //get categories data
        dispatch(setQuiz(data.data));
      }
      return data.data;
    } catch (err) {
      return rejectWithValue(
        err.response.data.message ||
        "'Something went wrong. Please try again later.'"
      );
    }
  }
);
export const getSubmittedQuizScore = createAsyncThunk(
  "getSubmittedQuizScore",
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const { data, status } = await api.getSubmittedQuizScore(body);
      if (status === 200) {
        //get categories data
        dispatch(setSubmittedQuizScore(data.data));
      }
      return data.data;
    } catch (err) {
      return rejectWithValue(
        err.response.data.message ||
        "'Something went wrong. Please try again later.'"
      );
    }
  }
);
export const getProgressDetails = createAsyncThunk(
  "getProgressDetails",
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const { data, status } = await api.getProgressDetails(body);
      if (status === 200) {
        //get categories data
        dispatch(setProgressDetails(data.data));
      }
      return data.data;
    } catch (err) {
      return rejectWithValue(
        err.response.data.message ||
        "'Something went wrong. Please try again later.'"
      );
    }
  }
);
export const getLiveSession = createAsyncThunk(
  "getLiveSession",
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const { data, status } = await api.getLiveSession(body);
      if (status === 200) {
        //get categories data
        dispatch(setLiveSession(data.data));
      }
      return data.data;
    } catch (err) {
      return rejectWithValue(
        err.response.data.message ||
        "'Something went wrong. Please try again later.'"
      );
    }
  }
);
export const getActiveAssignment = createAsyncThunk(
  "getActiveAssignment",
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const { data, status } = await api.getActiveAssignment(body);

      if (status === 200) {
        //get categories data
  console.log("zzzzzzzzzzAAAA zzzzzzzzzzzzzzzzzzz", data.data);

        dispatch(setActiveAssignment(data.data));
      }

      return data.data;
    } catch (err) {
      return rejectWithValue(
        err.response.data.message ||
        "'Something went wrong. Please try again later.'"
      );
    }
  }
);
export const getComment = createAsyncThunk(
  "getComment",
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const { data, status } = await api.getComment(body);
      if (status === 200) {
        //get categories data
        dispatch(setComment(data));
        // dispatch(setRefresh())
      }
      return data;
    } catch (err) {
      return rejectWithValue(
        err.response.data.message ||
        "'Something went wrong. Please try again later.'"
      );
    }
  }
);

export const addComment = createAsyncThunk(
  "addComment",
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const { data, status } = await api.addComment(body);
      if (status === 200) {
        dispatch(setAddComment())
        dispatch(setRefresh());
      }
      return data;
    } catch (err) {
      return rejectWithValue(
        err.response.data.message ||
        "'Something went wrong. Please try again later.'"
      );
    }
  }
);

export const getSubmittedAssignment = createAsyncThunk(
  "getSubmittedAssignment",
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const { data, status } = await api.getSubmittedAssignment(body);
      console.log("data==============", data);

      if (status === 200) {
        //get categories data
        dispatch(setSubmittedAssignment(data));
      }
      return data;
    } catch (err) {
      return rejectWithValue(
        err.response.data.message ||
        "'Something went wrong. Please try again later.'"
      );
    }
  }
);
export const getCertificate = createAsyncThunk(
  "getCertificate",
  async ({ id, studentId }, { rejectWithValue, dispatch }) => {
    try {

      console.log(id, studentId, "certificate thinfs");

      const { data, status } = await api.getCertificate(id, studentId);
      console.log("data==============", data);

      if (status === 200) {
        //get categories data
        dispatch(setCertificate(data.data));
      }
      return data.data;
    } catch (err) {
      return rejectWithValue(
        err.response.data.message ||
        "'Something went wrong. Please try again later.'"
      );
    }
  }
);

export const getSearchSuggession = createAsyncThunk(
  "getSearchSuggession",
  async (query, { rejectWithValue, dispatch }) => {
    try {
      const { data, status } = await api.getSearchSuggession(query);

      if (status === 200) {
        return data.data;
      }
    } catch (error) {
      console.log("error", error);
      return rejectWithValue(
        error.response.data.message ||
        "'Something went wrong. Please try again later.'"
      );
    }
  }
);



export const getAllActiveWebinars = createAsyncThunk(
  "getAllActiveWebinars",
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const { data, status } = await api.getAllActiveWebinars();
      console.log("data==============", data);

      if (status === 200) {
        //get categories data
        // dispatch(setCertificate(data.data));
      }
      return data.data;
    } catch (err) {
      return rejectWithValue(
        err.response.data.message ||
        "'Something went wrong. Please try again later.'"
      );
    }
  }
);


export const viewSingleWebinar = createAsyncThunk(
  "viewSingleWebinar",
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const { data, status } = await api.viewSingleWebinar(body);
      console.log("data==============", data);

      if (status === 200) {
        //get categories data
        // dispatch(setCertificate(data.data));
      }
      return data.data;
    } catch (err) {
      return rejectWithValue(
        err.response.data.message ||
        "'Something went wrong. Please try again later.'"
      );
    }
  }
);

export const courseSlice = createSlice({
  name: "courses",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setCatSubCategories: (state, action) => {
      state.catSubCategoriesData = action.payload;
    },
    setRating: (state, action) => {
      state.ratingData = action.payload;
    },
    setCourseLevel: (state, action) => {
      state.courseLevelData = action.payload;
    },
    setPayment: (state, action) => {
      state.paymentData = action.payload;
    },
    setDuration: (state, action) => {
      state.durationData = action.payload;
    },
    setCourses: (state, action) => {
      state.allCourseData = action.payload;
    },
    setCourseDetails: (state, action) => {
      state.courseDetailsData = action.payload;
    },
    setReviews: (state, action) => {
      state.reviewData = action.payload;
    },
    setURL: (state, action) => {
      state.urlData = action.payload;
    },
    setQuiz: (state, action) => {
      state.quizData = action.payload;
    },
    setProgressDetails: (state, action) => {
      state.progressDetailsData = action.payload;
    },
    setLiveSession: (state, action) => {
      state.liveSessionData = action.payload;
    },
    setSubmittedQuizScore: (state, action) => {
      state.submittedQuizScoreData = action.payload;
    },
    setActiveAssignment: (state, action) => {
      state.activeAssignmentData = action.payload;
    },
    setComment: (state, action) => {
      state.getCommentData = action.payload;
    },
    setAddComment: (state, action) => {
      state.addCommentData = action.payload;
    },
    setSubmittedAssignment: (state, action) => {
      state.submittedAssignmentData = action.payload;
    },
    setCertificate: (state, action) => {
      state.certificateData = action.payload;
    },
    setFilterValues: (state, action) => {
      state.filterValues = { ...state.filterValues, ...action.payload };
    },
    resetAndSetFilterValues: (state, action) => {
      state.filterValues = {
        ...initialState.filterValues, // Reset filterValues to its initial state
        ...action.payload, // Override specific fields in filterValues
      };
    },
    setRefresh: (state) => {
      state.isRefresh = !state.isRefresh;
    },
  },
  extraReducers: (builder) => {
    // getCourse
    builder.addCase(getAllCourses.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(getAllCourses.fulfilled, (state, action) => {
      state.isLoading = false;
      state.allCourseData = action.payload;
    });
    builder.addCase(getAllCourses.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMsg = action.payload;
    });
    // getCourse
    builder.addCase(getComment.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(getComment.fulfilled, (state, action) => {
      state.isLoading = false;
      state.getCommentData = action.payload;
    });
    builder.addCase(getComment.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMsg = action.payload;
    });
    // getSubmittedQuizScore
    builder.addCase(getSubmittedQuizScore.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(getSubmittedQuizScore.fulfilled, (state, action) => {
      state.isLoading = false;
      state.submittedQuizScoreData = action.payload;
    });
    builder.addCase(getSubmittedQuizScore.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMsg = action.payload;
    });
    //getQuiz
    builder.addCase(getQuiz.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(getQuiz.fulfilled, (state, action) => {
      state.isLoading = false;
      state.quizData = action.payload;
    });
    builder.addCase(getQuiz.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMsg = action.payload;
    });

    //getProgressDetails
    builder.addCase(getProgressDetails.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(getProgressDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.progressDetailsData = action.payload;
    });
    builder.addCase(getProgressDetails.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMsg = action.payload;
    });

    // getLiveSession
    builder.addCase(getLiveSession.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(getLiveSession.fulfilled, (state, action) => {
      state.isLoading = false;
      state.liveSessionData = action.payload;
    });
    builder.addCase(getLiveSession.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMsg = action.payload;
    });
    // getLiveSession
    builder.addCase(getActiveAssignment.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(getActiveAssignment.fulfilled, (state, action) => {
      state.isLoading = false;
      state.activeAssignmentData = action.payload;
    });
    builder.addCase(getActiveAssignment.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMsg = action.payload;
    });
  },
});

export const {
  setLoading,
  setCatSubCategories,
  setRating,
  setCourseLevel,
  setPayment,
  setDuration,
  setCourses,
  setCourseDetails,
  setReviews,
  setURL,
  setQuiz,
  setProgressDetails,
  setLiveSession,
  setSubmittedQuizScore,
  setActiveAssignment,
  setComment,
  setAddComment,
  setSubmittedAssignment,
  setCertificate,
  setFilterValues,
  resetAndSetFilterValues,
  setRefresh,
} = courseSlice.actions;

export default courseSlice.reducer;
